const SESSION_KEY__SOLUTION_STATE = "solution_state"
const SESSION_KEY__SOLUTION_REF = "solution_ref"

export const loadStateFromSessionStorage = (initValue) => {
    const value = sessionStorage.getItem(SESSION_KEY__SOLUTION_STATE)
    return value ? JSON.parse(value) : initValue
}

export const saveStateToSessionStorage = (value) => {
    sessionStorage.setItem(SESSION_KEY__SOLUTION_STATE, JSON.stringify(value))
}

export const loadRefFromSessionStorage = (initValue) => {
    const value = sessionStorage.getItem(SESSION_KEY__SOLUTION_REF)
    return value ? JSON.parse(value) : initValue
}

export const saveRefToSessionStorage = (value) => {
    sessionStorage.setItem(SESSION_KEY__SOLUTION_REF, JSON.stringify(value))
}

export const getProductElementProp = (products, productId, elementId, prop) => {
    return products.find(product => product.id === productId)?.elements.find(element => element.id === elementId)?.[prop]
}

export const isWallToWallMove = (currentSolutionProducts, updatedProducts) => {
    let isWallToWallMove = false

    currentSolutionProducts.forEach((currentSolutionProduct) => {
        const updatedProduct = updatedProducts.find(updatedProduct => updatedProduct.id === currentSolutionProduct.id)
        currentSolutionProduct.elements.forEach((currentElement, currentElementIndex) => {
            const updatedElement = updatedProduct.elements[currentElementIndex]
            if (currentElement.mountingSurface.index !== updatedElement.mountingSurface.index) {
                isWallToWallMove = true
            }
        })
    })

    return isWallToWallMove
}

export const requestPayload = (roomId, products) => {
    return {
        roomId: roomId,
        products: products.map(product => {
            return {
                sku: product.sku,
                parentSku: product.parentSku,
                quantity: product.quantity,
                mountingSurfaceType: product.mountingSurfaceType,
                elements: product.elements
            }
        })
    }
}